import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../../domain/QueryKeys';

import { ExperienceEntry, getExperiences } from '@contentful/getExperiences';

export const useExperiences = (): UseQueryResult<ExperienceEntry[]> => {
    return useQuery({
        queryKey: [QueryKeys.useExperiences],
        queryFn: async () => {
            const experienceData = await getExperiences();
            return experienceData;
        },
        enabled: true,
        staleTime: 5 * 60 * 60,
    });
};
